function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 63,
  height: 63,
  rx: 31.5,
  stroke: "#1A1A1A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.349 28.815a1.75 1.75 0 001.401-1.714V24A1.75 1.75 0 0044 22.25H20A1.75 1.75 0 0018.25 24v3.101a1.75 1.75 0 001.401 1.714 3.25 3.25 0 010 6.375 1.75 1.75 0 00-1.401 1.709V40A1.75 1.75 0 0020 41.75h24A1.75 1.75 0 0045.75 40v-3.101a1.75 1.75 0 00-1.401-1.714 3.25 3.25 0 010-6.375v.005zM19.75 40v-3.101a.25.25 0 01.199-.244 4.75 4.75 0 000-9.31.25.25 0 01-.199-.25V24a.25.25 0 01.25-.25h7.25v16.5H20a.25.25 0 01-.25-.25zm24.301-3.345a.25.25 0 01.199.244V40a.25.25 0 01-.25.25H28.75v-16.5H44a.25.25 0 01.25.25v3.101a.25.25 0 01-.199.25 4.75 4.75 0 000 9.31v-.006z",
  fill: "#1A1A1A"
});

function SvgCircleTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCircleTicket;